import globalConfig from '../globalConfig.js';

/** 登录页 activity 标识（写入 activity_name） */
const LOGIN_PAGE_AID = 'loginPage';

/** 构建版本信息（webpack DefinePlugin 注入） */
export const getPageVersion = () => process.env.BUILD_VERSION || ''

/**
 * 统一上报到 window.activityDataLayer（webLogin 登录页）
 * @param {string} eventName
 * @param {Object} [opts]
 * @param {string|number} [opts.gameId]
 * @param {string} [opts.eventType]
 * @param {string} [opts.eventReason]
 * @param {Object|string} [opts.eventValue]
 */
export function reportActivityPoint(eventName, opts = {}) {
  try {
    const {
      gameId = '',
      eventType = '',
      eventReason = '',
      eventValue
    } = opts;
    const payload = {
      eventName,
      aid: LOGIN_PAGE_AID,
      gameId: gameId || globalConfig.getHrefParamUndecode('gameId'),
    };
    if (eventType) payload.eventType = eventType;
    if (eventReason) payload.eventReason = eventReason;
    if (eventValue !== undefined && eventValue !== null && eventValue !== '') {
      payload.eventValue =
        typeof eventValue === 'object'
          ? JSON.stringify(eventValue)
          : eventValue;
    }
    window?.activityDataLayer?.push(payload);
  } catch {
    // ignore
  }
}

/** 页面访问 + 上报 view_page（含构建版本号/时间戳） */
export function reportViewPage(gameId = '') {
  reportActivityPoint('view_page', {
    gameId,
    eventValue: { version: getPageVersion() }
  });
}

/** Google 验证码相关埋点 */
export function reportRecaptchaActivityPoint(eventName, eventValue = {}) {
  reportActivityPoint(eventName, {
    eventType: 'google_recaptcha',
    eventReason: 'ro_login',
    eventValue
  });
}

export default reportActivityPoint;
